
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/inventory/denison",
      function () {
        return require("private-next-pages/en/inventory/denison.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/inventory/denison"])
      });
    }
  